import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboardApi'
import { useTenantStore } from '../../../shared/stores/useTenantStore'

export const useDashboardSummary = () => {
  const activeMerchantId = useTenantStore((s) => s.activeMerchant?.id)

  // No merchant selected is a legitimate state, not a "nothing to show yet" one — ApiFetch
  // only attaches x-tenant-id when a merchant IS selected, so with none selected this hits
  // osprey-api's all-merchants aggregate (PE-2245, already fixed server-side). Gating the
  // query on activeMerchantId meant that aggregate never rendered at all; the query must run
  // in both states, just keyed separately so switching merchants doesn't show stale data.
  return useQuery({
    queryKey: ['dashboard', 'summary', activeMerchantId ?? 'all'],
    queryFn: () => dashboardApi.getSummary(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  })
}

// Simplified hook that returns summary data and states
export const useDashboardSummaryData = () => {
  const { data, isLoading, error, refetch } = useDashboardSummary()
  
  return {
    summary: data,
    isLoading,
    error,
    refetch
  }
}